<div class="card-body">
    <div class="row">
        <div class="col-md-12">
            <button (click)="rotate()" class="btn btn-success btn-rounded">Click para Rotar</button>
            <hr>
        </div>
    </div>

    <div class="row">
        <div class="col-md-1">&nbsp;</div>
        <div class="col-md-10">
            <!-- Remember to add binding to tag -->
            <img [@rotatedState]='state' [src]="src" style="max-height:800px;max-width:900px;height:auto;width:auto;">
        </div>
        <div class="col-md-1">&nbsp;</div>
    </div>
</div>